// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"5e9004db","453":"672da07d","471":"0d61c156","820":"459ab5bb"}[chunkId] + ".chunk.js";
};